/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice\src\Content\Offers\OfferRowUserSingle\OfferRowUser.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_backoffice
 * Created Date: Wednesday July 3rd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday July 3rd 2024 4:42:51 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableCell, TableRow } from "@mui/material";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from "MultiLanguage/TranslationWrapper";
import { OfferUserType } from "Types/offer.type";
import { Link } from "react-router-dom";
import Styles from "Content/OfferUser/OfferRowUserSingle/OfferRowUser.module.css";
import { FaDotCircle } from "react-icons/fa";
import { offerColor } from "Utils/ThemeColor";
import { useEffect, useState } from "react";
import CarService from "Services/Cars/CarService";

type OfferRowUserProps = {
    Offer: OfferUserType;
};

export function OfferRowUser(props: OfferRowUserProps) {
    const [carImg, setCarImg] = useState(<img src={`/PH${props.Offer.InSell.Car.SubSection}.svg`} alt={"No Picture to display"} />);

    useEffect(() => {
        CarService.getPicturesFirstCar(props.Offer.InSell.Car.id).then((val: {data: any}) => {
            if (val.data)
                setCarImg(<img className="w-75" src={val.data.Pict.URI} alt={"Car Picture"} />);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    return (
        <TableRow hover >
            <TableCell align="center" className={`${Styles.cells}`}>
                {carImg}
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{new Date(props.Offer.CreatedAt).toLocaleString()}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <Link to={`${RouterPathResolver.routeCarsId.path.replace(":id", props.Offer.InSell.Car.id)}`}>
                    {`${props.Offer.InSell.Car.Brand} ${props.Offer.InSell.Car.Model}`}
                </Link>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{props.Offer.Amount}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <div className={`${Styles.status}`}>
                    <FaDotCircle className="me-2" fill={`${offerColor(props.Offer.Status as unknown as string)}`}/>
                    <p className="m-0">{translator.decode(`Status.${props.Offer.Status}`)}</p>
                </div>
            </TableCell>
        </TableRow>
    )
};
